import React, { useMemo } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  Card,
  CardContent,
  Typography,
  Box,
  Link as MuiLink
} from '@mui/material';
import times from 'lodash/times';
import { useGetTopDealsToday } from '@hooks/useTopDeals';
import DealCard, { SkeletonDealCard } from '@components/DealCard';

const TopDealsCard = ({
  tag,
  renderInFeed = false
}: {
  tag: string;
  renderInFeed?: boolean;
}) => {
  const { data: topDealsData, isLoading } = useGetTopDealsToday();

  const mode = topDealsData?.mode || 'today';
  const deals = useMemo(
    () => topDealsData?.deals.slice(0, 3) || [],
    [topDealsData]
  );
  const title =
    mode === 'today'
      ? `Today's Top 3 Amazon Deals`
      : `This Week's 3 Top Amazon Deals`;

  const renderTopDealsContent = () => {
    return (
      <>
        <Box id="top-deals" />
        <Typography variant="h6" component="h2" gutterBottom>
          {isLoading ? 'Loading most popular...' : title}
        </Typography>
        {deals.map((deal) => (
          <DealCard
            key={deal.ASIN}
            {...deal}
            shouldLazyLoad={false}
            tag={tag}
          />
        ))}
        {isLoading ? times(3, (i) => <SkeletonDealCard key={i} />) : null}
        {!isLoading ? (
          <MuiLink
            component={RouterLink}
            variant="h5"
            to="/p/best-selling-deals"
            rel="noopener noreferrer"
            sx={{
              fontWeight: 'bold'
            }}
            onClick={() => {
              // scroll to top
              setTimeout(() => {
                window.scrollTo({
                  top: 0,
                  behavior: 'smooth'
                });
              }, 150);
            }}
          >
            See all 30 of our top Amazon deals &gt;&gt;&gt;
          </MuiLink>
        ) : null}
      </>
    );
  };

  if (renderInFeed) {
    return (
      <>
        <Box
          component="aside"
          sx={{
            display: 'block',
            // if more than 900px display none
            '@media (min-width: 900px)': {
              display: 'none'
            }
          }}
        >
          <Box padding="24px 10px">{renderTopDealsContent()}</Box>
        </Box>
      </>
    );
  }

  return (
    <Card
      style={{
        margin: '0px 0rem 1rem 1rem'
      }}
      component="aside"
    >
      <CardContent>{renderTopDealsContent()}</CardContent>
    </Card>
  );
};

export default TopDealsCard;
